export const CONFIG = {
  API: {
    SILENT_REQUEST: { context: { headers: { 'x-silent-header': 'silent' } } }
  },
  ROC_CALCULATOR: {
    URL: 'https://api-dev-roc-calculator.returnon.college/roc-calculator'
  },
  DEFAULTS: {
    SEARCH_RADIUS_IN_MILES: 25,
    AGE: 18,
    RETIREMENT_AGE: 67,
    YEARS_TO_COMPLETE: 4,
    PAY_OFF_FEDERAL_LOAN_IN_YEARS: 10,
    PAY_OFF_PRIVATE_LOAN_IN_YEARS: 8
  },
  MINIMUM_AGE: 13,
  MAXIMUM_AGE: 70,
  RETIREMENT_AGE_MINIMUM: 40,
  RETIREMENT_AGE_MAXIMUM: 80,
  YEARS_TO_COMPLETE_MINIMUM: 1,
  YEARS_TO_COMPLETE_MAXIMUM: 8,
  COST_OF_LIVING_ADJUSTMENT: 0.03,
  PELL_AWARD_ADJUSTMENT: 0.02,

  IBR_YEARS_TO_PAY_OFF_FEDERAL_LOAN: 20,
  MAXIMUM_FEDERAL_LOAN_AMOUNT: 31000,
  PAY_OFF_LOAN_MINIMUM_IN_YEARS: 0,
  PAY_OFF_LOAN_MAXIMUM_IN_YEARS: 30,

  FEDERAL_LOAN_INTEREST_RATE: 0.0794,
  PRIVATE_LOAN_INTEREST_RATE: 0.07,

  LOAN_CONSTANTS: {
    DEPENDENT: {
      FEDERAL_SUBSIDIZED: {
        YEAR_1: 3500,
        YEAR_2: 4500,
        YEAR_3_PLUS: 5500,
        TOTAL: 23000
      },
      TOTAL_FEDERAL_LOAN: {
        YEAR_1: 5500,
        YEAR_2: 6500,
        YEAR_3_PLUS: 7500,
        TOTAL: 31000
      }
    },
    INDEPENDENT: {
      FEDERAL_SUBSIDIZED: {
        YEAR_1: 3500,
        YEAR_2: 4500,
        YEAR_3_PLUS: 5500,
        TOTAL: 23000
      },
      TOTAL_FEDERAL_LOAN: {
        YEAR_1: 9500,
        YEAR_2: 10500,
        YEAR_3_PLUS: 12500,
        TOTAL: 57500
      }
    }
  }
};
